import { v4 } from 'uuid';
import storage from '../storage';

let deviceId = storage.getItem('deviceId') as string;
if (!deviceId) {
  deviceId = v4();
  try {
    storage.setItem('deviceId', deviceId);
  }
  catch (e) {
    console.log('Failed to store', e); // tslint:disable-line:no-console
  }
}

export default deviceId;
